import { z } from 'zod';

import { entityIdSchema, nonEmptyTextSchema, sha256Schema } from './primitives';

export const inspectionSpecialTemplateItemSchema = z
  .object({
    itemId: entityIdSchema,
    prompt: nonEmptyTextSchema.max(300),
    sequence: z.number().int().positive(),
  })
  .strict();

export const inspectionSpecialTemplateSectionSchema = z
  .object({
    sectionId: entityIdSchema,
    title: nonEmptyTextSchema.max(100),
    sequence: z.number().int().positive(),
    items: z.array(inspectionSpecialTemplateItemSchema).min(1).max(100),
  })
  .strict();

export const inspectionSpecialTemplateRevisionSchema = z
  .object({
    tenantId: z.literal('kop'),
    siteId: z.literal('eumseong'),
    templateId: entityIdSchema,
    templateVersion: z.number().int().positive(),
    name: nonEmptyTextSchema.max(120),
    kind: z.literal('special'),
    sections: z.array(inspectionSpecialTemplateSectionSchema).min(1).max(50),
    itemCount: z.number().int().positive().max(500),
    contentHash: sha256Schema,
    contentHashAlgorithm: z.literal('sha256'),
    immutable: z.literal(true),
    recordedAt: z.string().datetime({ offset: true }),
    recordedBy: entityIdSchema,
  })
  .strict();

export const inspectionSpecialTemplateCommandPayloadSchema = z
  .object({
    name: nonEmptyTextSchema.max(120),
    sections: z
      .array(
        z
          .object({
            sectionId: entityIdSchema,
            title: nonEmptyTextSchema.max(100),
            items: z
              .array(
                z
                  .object({
                    itemId: entityIdSchema,
                    prompt: nonEmptyTextSchema.max(300),
                  })
                  .strict(),
              )
              .min(1)
              .max(100),
          })
          .strict(),
      )
      .min(1)
      .max(50),
  })
  .strict();

export type InspectionSpecialTemplateRevision = z.infer<
  typeof inspectionSpecialTemplateRevisionSchema
>;
